import React from 'react';
import { BiPlus } from 'react-icons/bi'
import styled from 'styled-components';
import Modal from './Modal';

const Wrapper = styled.div`
    display: flex;
    width: 220px;
    flex-direction: column;
    padding: 75px 20px 20px 20px;
    border-radius: 10px;
    box-shadow: 1px 1px 15px #e2b66b;
    h2 {
        font-size: 16px;
        font-weight: 600;
    }
    .verMais {
        display: flex;
        cursor: pointer;
        gap: 4px;
        align-items: center;
        margin-top: 12px;
        span {
            font-size: 12px;
            font-weight: 500;
        }
    }
`
interface CardProps {
    modal: boolean | undefined,
    setModal: ((arg0: boolean) => void) | undefined
}

function Card({ modal, setModal }: CardProps) {


    const handleClick = () => {
        if(setModal) {
            setModal(true)
        }
    }

    return (
        <div>
            <Wrapper>
                    <h2>Gerenciamento<br/>de redes sociais</h2>
                    <span className='verMais' onClick={handleClick}>
                        <span>Ver mais</span>
                        <BiPlus />
                    </span>
            </Wrapper>
            {modal? (
                <Modal setModal={setModal} />
            ) : (
                null
            )}

        </div>
    );
}

export default Card;